module.exports = __webpack_public_path__ + "static/media/project-dashboard-list.35d534e6.scss";


//////////////////
// WEBPACK FOOTER
// ./src/sass/project-dashboard-list.scss
// module id = 2217
// module chunks = 0